import { render, staticRenderFns } from "./PermitSearch.vue?vue&type=template&id=5a2c5764&"
import script from "./PermitSearch.vue?vue&type=script&lang=js&"
export * from "./PermitSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports